import { badges, icons, logos } from 'common'
import styled, { css } from 'styled-components'

const designerCSS = css`
  .yolo_token {
    background-image: url(${logos.yolo_token});
    background-position: center center;
    background-size: 12px 12px;
    background-repeat: no-repeat;
    width: 12px;
    height: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .yolo_token.size_40 {
    background-size: 40px 40px;
    width: 40px;
    height: 40px;
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/achievements.css */
  .achievements_page_wrapper {
    width: 100%;
    padding: 0 40px;
    min-width: 0;
    margin: 30px 0 0 0;
    overflow-y: auto;
  }
  .achievements_page_wrapper h1 {
    font-size: 2.5rem;
    font-weight: 300;
    letter-spacing: -0.02em;
  }
  .achievements_page_wrapper h2 {
    font-size: 0.9rem;
    letter-spacing: -0.01em;
    padding: 10px 0 40px 0;
  }
  .achievements_page_wrapper h3 {
    font-size: 1.4rem;
    font-weight: 600;
    margin: 0 0 15px 0;
  }
  .achievements_page_wrapper .ach_current_box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 0 0 0 0;
  }
  .achievements_page_wrapper .ach_current_status_wrapper {
    padding: 0;
    margin: 5px 20px 5px 0;
    width: fit-content;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .achievements_page_wrapper .ach_current_status_wrapper.total_points,
  .achievements_page_wrapper .ach_current_status_wrapper.points_needed {
    padding: 0;
  }
  .achievements_page_wrapper .ach_current_status_wrapper.total_points {
    margin-right: 0;
  }
  .achievements_page_wrapper .ach_current_status_wrapper.total_points .ach_current_status {
    border-radius: 10px 0 0 10px;
    border-right: 1px solid hsla(0, 0%, 100%, 0.15);
  }
  .achievements_page_wrapper .ach_current_status_wrapper.points_needed .ach_current_status {
    border-radius: 0 10px 10px 0;
  }
  .achievements_page_wrapper .ach_current_status_wrapper:nth-child(4),
  .achievements_page_wrapper .ach_current_status_wrapper:nth-child(5) {
    padding: 0;
  }
  .achievements_page_wrapper .ach_current_status {
    padding: 20px 30px;
    background: hsla(0, 0%, 100%, 0.1);
    border-radius: 10px;
    width: fit-content;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 80px;
  }
  .achievements_page_wrapper .ach_current_status_wrapper .intro {
    font-size: 0.7rem;
    margin: 0 0 7px 0;
    line-height: 120%;
  }
  .achievements_page_wrapper .ach_current_status_wrapper .ach_yolo_tokens {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    font-size: 1.6rem;
  }
  .achievements_page_wrapper .ach_current_status_wrapper .ach_yolo_tokens .yolo_token {
    margin: 0 0 0 10px;
  }
  .achievements_page_wrapper .ach_current_status_wrapper .ach_points {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    font-size: 1.6rem;
  }
  .achievements_page_wrapper .ach_current_status_wrapper .ach_points strong {
    font-weight: 800;
    font-size: 1.6rem;
    padding: 0 5px 0 0;
  }
  .achievements_page_wrapper .ach_current_status_wrapper .tier_name {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .achievements_page_wrapper .ach_current_status_wrapper .tier_name strong {
    font-weight: 800;
    font-size: 1.2rem;
  }
  .achievements_page_wrapper .ach_current_status_wrapper .tier_name strong div {
    font-weight: 800;
    font-size: 1.2rem;
    width: 10px;
    margin: 0 0 0 5px;
  }
  .achievements_page_wrapper .ach_current_status_wrapper .tier_name div {
    border-bottom: 1px dotted hsla(0, 0%, 100%, 0.4);
    display: inline-block;
    width: fit-content;
    margin: 5px 0 0 0;
    font-size: 0.7rem;
  }
  .achievements_page_wrapper .ach_current_status_wrapper .tier_name div:hover {
    cursor: pointer;
  }

  .achievements_page_wrapper .ach_current_status_wrapper .badge_icon {
    margin: 0 20px 0 30px;
    transform: scale(250%);
    height: 100%;
    transform-origin: 50%;
  }

  .badge_icon {
    background-position: center center;
    background-size: 20px auto;
    background-repeat: no-repeat;
    width: 20px;
    height: 20px;
    margin: 0 0 0 5px;
  }

  .tier_indicator.rekt_newbie {
    background: hsla(200, 74%, 57%, 0.1);
    border: 1px solid hsla(200, 74%, 57%, 0.4);
  }
  .achievements_table_wrapper {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    position: relative;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    margin: 40px 0 40px 0;
  }
  .achievements_table_wrapper h3 {
    display: flex;
    align-items: center;
  }
  .achievements_table_wrapper .grid-header {
    display: contents;
  }
  .achievements_table_wrapper .grid-content {
    display: contents;
  }
  .achievements_table_wrapper .table_row {
    display: contents;
  }
  .achievements_table_wrapper .table_row:hover label {
    background: hsla(0, 0%, 100%, 0.1);
  }
  .achievements_table_wrapper .grid-body .grid-header label {
    position: sticky;
    top: 0;
    font-size: 0.8rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    white-space: nowrap;
    border-top: 1px solid transparent;
    cursor: pointer;
    color: hsl(0, 0%, 100%, 0.4);
    background: hsla(0, 0%, 0%, 0.2);
    padding: 9px 6px 8px 6px;
    z-index: 1;
    opacity: 1;
  }
  .achievements_table_wrapper .grid-body .grid-content label {
    padding: 7px 6px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    font-size: 0.8rem;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    opacity: 1;
    line-height: 130%;
  }
  .achievements_table_wrapper .grid-body .grid-content label.reward {
    font-weight: 800;
  }
  .achievements_table_wrapper .grid-header label.done,
  .achievements_table_wrapper .grid-content label.done {
    padding-left: 30px;
  }
  .achievements_table_wrapper .grid-body.your_bids_iw {
    display: grid;
    grid-template-columns: 0.15fr 0.75fr 1.75fr 0.25fr 0.5fr;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
  }
  .achievements_table_wrapper label.done .checked {
    background: url(${icons.ach_check_checked_3}) center center / 24px auto no-repeat;
    width: 24px;
    height: 25px;
    position: relative;
    top: -1px;
  }
  .achievements_table_wrapper label.done .unchecked {
    background: url(${icons.ach_check_unchecked_3}) center center / 24px auto no-repeat;
    width: 24px;
    height: 25px;
    position: relative;
    top: -1px;
  }
  .tiers_table_wrapper {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    position: relative;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    margin: 5px 0 40px 0;
  }
  .tiers_table_wrapper h3 {
    display: flex;
    align-items: center;
  }

  .tiers_table_wrapper .grid-header {
    display: contents;
  }
  .tiers_table_wrapper .grid-content {
    display: contents;
  }
  .tiers_table_wrapper .table_row {
    display: contents;
  }
  .tiers_table_wrapper .table_row.current label {
    background: hsla(221, 73%, 47%, 0.15);
  }
  .tiers_table_wrapper .grid-body .grid-header label {
    position: sticky;
    top: 0;
    font-size: 0.8rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    white-space: nowrap;
    border-top: 1px solid transparent;
    cursor: pointer;
    color: hsl(0, 0%, 100%, 0.4);
    background: hsla(0, 0%, 0%, 0.2);
    padding: 9px 6px 8px 6px;
    z-index: 1;
    opacity: 1;
  }
  .tiers_table_wrapper .grid-body .grid-content label {
    padding: 25px 6px 24px 6px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    font-size: 1rem;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    opacity: 1;
    line-height: 130%;
  }
  .tiers_table_wrapper .grid-header label.tier_level,
  .tiers_table_wrapper .grid-content label.tier_level {
    padding-left: 30px;
  }
  .tiers_table_wrapper .grid-content label.tier_level {
    color: #737478;
  }
  .tiers_table_wrapper .grid-content label.tier {
    font-weight: 600;
  }
  .tiers_table_wrapper .grid-body.your_bids_iw {
    display: grid;
    grid-template-columns: 0.15fr 1.5fr 0.75fr 0.75fr;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
  }
  .tiers_table_wrapper .badge_icon {
    margin: 0 0 0 15px;
    transform: scale(150%);
    height: 100%;
    transform-origin: 50%;
  }
`
const comingSoon = css`
  .achievements_page_wrapper .ach_current_status_wrapper.coming_soon {
    max-width: 220px;
  }
  .achievements_page_wrapper .ach_current_status_wrapper.coming_soon .ach_points,
  .achievements_page_wrapper .ach_current_status_wrapper.coming_soon .ach_yolo_tokens {
    font-weight: 400;
    font-size: 0.7rem;
    padding: 0;
    line-height: 130%;
    display: inline;
  }
  .achievements_page_wrapper .ach_current_status_wrapper.coming_soon .ach_points strong,
  .achievements_page_wrapper .ach_current_status_wrapper.coming_soon .ach_yolo_tokens strong {
    display: block;
    font-weight: 800;
    text-transform: uppercase;
    font-size: 0.7rem;
    color: #277fff;
  }
  .achievements_page_wrapper .ach_current_status_wrapper.coming_soon .ach_points a,
  .achievements_page_wrapper .ach_current_status_wrapper.coming_soon .ach_yolo_tokens a {
    text-decoration: none;
    color: #fff;
    display: inline;
    border-bottom: 1px dotted hsla(0, 0%, 100%, 0.4);
  }
  .achievements_page_wrapper .ach_current_status_wrapper.coming_soon .ach_points a:hover,
  .achievements_page_wrapper .ach_current_status_wrapper.coming_soon .ach_yolo_tokens a:hover {
    border-bottom: 1px dotted hsla(0, 0%, 100%, 0.9);
  }
`
const developerCSS = css`
  .scroll_wrapper {
    margin-top: 70px;
    position: absolute;
    overflow-y: auto;
    overflow-x: hidden;
    top: 0;
    left: 0;
    width: 100%;
    height: calc(100% - 70px);
  }
`

export const AchievementCSS = styled.div`
  position: relative;
  overflow: hidden;
  padding-top: 70px;
  height: 100%;
  ${designerCSS}
  ${comingSoon}
  ${developerCSS}
`
